module.exports = __webpack_public_path__ + "img/white-square-button.5da6354d.png";